export default __webpack_public_path__ + "static/logo.min-65938e4445aea5c43569199214044b9d.svg";